/*
  新着の並べ直し。
  data-na-root を持つ要素（新着商品ページ・トップの NEW ARRIVALS）について、
  コレクション「新着商品」が250点を超えて複数ページになるとき、全ページを
  sections/new-arrivals-feed で読み込み、掲載日の新しい順に並べ直して差し替える。

  data-na-pages   コレクションのページ数（Liquid の paginate.pages）。1なら何もしない
  data-na-kind    'grid'（新着ページ）/ 'home'（トップのレール）
  data-na-cutoff  これより前の掲載日は出さない（YYYY-MM-DD、Liquid で計算）
  data-na-limit   表示数の上限（0 または未指定なら上限なし）
  子要素 [data-na-target] の中身を差し替え、[data-na-empty] を隠す。
  読み込みに失敗したときは、サーバーで出した1ページ目の結果をそのまま残す。
*/
(function () {
  var FEED = '/collections/new-arrivals?section_id=new-arrivals-feed&page=';
  var cache = {};

  function load(page) {
    if (!cache[page]) {
      cache[page] = fetch(FEED + page, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    }
    return cache[page];
  }

  function parse(html, kind) {
    var out = [];
    if (!html) return out;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    doc.querySelectorAll('template[data-na-item]').forEach(function (t) {
      var k = t.content.querySelector('[data-kind="' + kind + '"]');
      if (k) out.push({ date: t.getAttribute('data-date'), pos: Number(t.getAttribute('data-pos')) || 0, html: k.innerHTML });
    });
    return out;
  }

  function run(root) {
    var pages = Number(root.getAttribute('data-na-pages')) || 1;
    if (pages < 2) return;
    var kind = root.getAttribute('data-na-kind') || 'grid';
    var cutoff = root.getAttribute('data-na-cutoff') || '';
    var limit = Number(root.getAttribute('data-na-limit')) || 0;

    var reqs = [];
    for (var p = 1; p <= pages; p++) reqs.push(load(p));

    Promise.all(reqs).then(function (htmls) {
      var items = [];
      htmls.forEach(function (h) { items = items.concat(parse(h, kind)); });
      items = items.filter(function (i) { return i.date && i.date >= cutoff; });
      items.sort(function (a, b) {
        if (a.date !== b.date) return a.date < b.date ? 1 : -1;
        return a.pos - b.pos;
      });
      if (limit) items = items.slice(0, limit);
      if (!items.length) return;

      var target = root.querySelector('[data-na-target]');
      if (!target) return;
      target.innerHTML = items.map(function (i) { return i.html; }).join('');
      target.hidden = false;
      root.querySelectorAll('[data-na-empty]').forEach(function (e) { e.hidden = true; });
      root.hidden = false;
    });
  }

  function init() {
    document.querySelectorAll('[data-na-root]').forEach(run);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
